<div class="bg-grey-500 relative">
    <div
        class="inner-page-wrapper flex w-full flex-col gap-x-56 gap-y-24 py-40 md:flex-row md:items-center md:justify-between md:p-24"
    >
        <div class="absolute top-0 right-0 left-0 z-[1] block h-[120px] w-full bg-white md:hidden"></div>
        <div class="relative z-10 flex w-full flex-col gap-x-56 gap-y-24 md:flex-row md:items-center">
            <ui-m040-c070-contact-person
                class="block w-full max-w-[262px]"
                [data]="contact()"
                [isFirstView]="isFirstView()"
                showPhone="false"
                showMail="false"
            />
            <ng-content />
        </div>
        <div class="flex flex-col gap-16 md:shrink-0 md:grow md:flex-row md:justify-end">
            <a class="group button-primary w-full md:w-auto" [hyundaiRouterLink]="ctaLink()">
                <i class="icon-phone text-24 group-hover:animate-wiggle mr-8 text-white" aria-hidden="true"></i>
                {{ cta() }}
            </a>
            @if (ctaSecondary() && ctaSecondaryLink()) {
                <a
                    class="group button-secondary w-full justify-center bg-white md:w-auto"
                    [hyundaiRouterLink]="ctaSecondaryLink()"
                    (click)="ctaSecondaryClicked.emit()"
                >
                    <i class="icon-whatsapp text-24 group-hover:animate-wiggle text-accent mr-8" aria-hidden="true"></i>
                    {{ ctaSecondary() }}
                </a>
            }
        </div>
    </div>
</div>
